import { apiClient } from "@/lib/api-client";
import {
  Candidate,
  CandidateDocument,
  CandidateTimeline,
  DocumentDownloadResponse,
} from "../dtos/Candidate"

export async function getCandidateDetails(
  organizationId: string | null,
  candidateId: string,
): Promise<Candidate> {
  const response = await apiClient.get<Candidate>(
    `/organizations/${organizationId}/candidates/${candidateId}`,
  )
  return response.data
}

export async function getCandidateTimeline(
  organizationId: string | null,
  candidateId: string,
): Promise<CandidateTimeline[]> {
  const response = await apiClient.get<CandidateTimeline[]>(
    `/organizations/${organizationId}/candidates/${candidateId}/timeline`,
  )
  return response.data
}

export async function getCandidateDocuments(
  organizationId: string | null,
  candidateId: string,
): Promise<CandidateDocument[]> {
  const response = await apiClient.get<CandidateDocument[]>(
    `/organizations/${organizationId}/candidates/${candidateId}/documents`,
  )
  return response.data
}

export async function downloadCandidateDocument(
  organizationId: string | null,
  documentId: string,
): Promise<DocumentDownloadResponse> {
  const response = await apiClient.get<DocumentDownloadResponse>(
    `/organizations/${organizationId}/documents/${documentId}/download`,
  )
  return response.data
}


export async function uploadCandidateDocument(
  organizationId: string | null,
  candidateId: string,
  file: File,
  fileName?: string,
): Promise<void> {
  const formData = new FormData()
  formData.append("file", file)
  if (fileName) {
    formData.append("fileName", fileName)
  }
  await apiClient.post(
    `/organizations/${organizationId}/candidates/${candidateId}/documents`,
    formData,
  )
}
